import React from 'react'

import TopicList from 'app/PelatihanMandiriPage/pages/TopicList'
import PageHeader from 'app/PelatihanMandiriPage/components/PageHeader'

const DaftarTopikPage = () => {
  return <TopicList />
}

DaftarTopikPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10',
  header: PageHeader,
}

export default DaftarTopikPage
